import React from 'react';
import { IconProps } from '../IconProps';

export const DisplayIcon: React.FC<IconProps> = ({
	width = 20,
	height = 21,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 21"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.125 5.42539C8.81536 5.42539 9.375 4.88813 9.375 4.22539C9.375 3.56265 8.81536 3.02539 8.125 3.02539C7.43464 3.02539 6.875 3.56265 6.875 4.22539C6.875 4.88813 7.43464 5.42539 8.125 5.42539Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.37598 4.2251H15.626"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.37598 4.2251H6.87598"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.875 10.2252C12.5654 10.2252 13.125 9.68794 13.125 9.0252C13.125 8.36245 12.5654 7.8252 11.875 7.8252C11.1846 7.8252 10.625 8.36245 10.625 9.0252C10.625 9.68794 11.1846 10.2252 11.875 10.2252Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.626 9.02539H4.37598"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15.626 9.02539H13.126"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.25 15.0254C11.3212 16.3116 11.753 17.5554 12.5 18.6254H7.5C8.24695 17.5554 8.67884 16.3116 8.75 15.0254"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.62598 18.625H14.376"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M0.625977 12.625H19.376"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.625977 2.125C0.625977 1.29657 1.29755 0.625 2.12598 0.625H17.876C18.7044 0.625 19.376 1.29657 19.376 2.125V13.525C19.376 14.3534 18.7044 15.025 17.876 15.025H2.12598C1.29755 15.025 0.625977 14.3534 0.625977 13.525V2.125Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const GeneralIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.625977 1.875C0.625977 1.18464 1.18562 0.625 1.87598 0.625H18.126C18.8163 0.625 19.376 1.18464 19.376 1.875V18.125C19.376 18.8154 18.8163 19.375 18.126 19.375H1.87598C1.18562 19.375 0.625977 18.8154 0.625977 18.125V1.875Z"
			stroke={stroke}
			strokeWidth="1.04167"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10.626 13.125H15.626"
			stroke={stroke}
			strokeWidth="1.04167"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M4.37598 13.125H6.87598"
			stroke={stroke}
			strokeWidth="1.04167"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.626 13.125C10.626 14.1604 9.78668 14.9998 8.75125 15C7.71583 15.0002 6.87628 14.161 6.87598 13.1256C6.87567 12.0901 7.71472 11.2505 8.75014 11.25C9.24757 11.2498 9.7247 11.4472 10.0765 11.7989C10.4283 12.1505 10.626 12.6276 10.626 13.125V13.125Z"
			stroke={stroke}
			strokeWidth="1.04167"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.876 6.875H4.37598"
			stroke={stroke}
			strokeWidth="1.04167"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.626 6.875C15.626 5.83957 14.7867 5.00015 13.7513 5C12.7158 4.99985 11.8763 5.83902 11.876 6.87444C11.8757 7.90987 12.7147 8.74954 13.7501 8.75C14.7858 8.75 15.6255 7.91067 15.626 6.875Z"
			stroke={stroke}
			strokeWidth="1.04167"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const KeyboardIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.625 12.375C0.625 10.7181 1.96815 9.375 3.625 9.375H16.375C18.0319 9.375 19.375 10.7181 19.375 12.375V16.375C19.375 18.0319 18.0319 19.375 16.375 19.375H3.625C1.96815 19.375 0.625 18.0319 0.625 16.375V12.375Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.625 11.875H6.875"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M13.125 11.875H14.375"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.375 11.875H10.625"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.75 14.375H5"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.5 14.375H8.75"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.25 14.375H12.5"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M15 14.375H16.25"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.625 16.875H14.375"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M5.10957 4.375C5.40527 2.5 6.95527 1.5 9.99527 1.5C13.0353 1.5 14.5853 2.5 14.8812 4.375"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.51855 6.875V6.125"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.4688 6.875V6.125"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.99414 6.875V6.125"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const PrivacySecurityIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.87503 3.26994V9.61494C1.87506 13.7204 4.40334 17.4018 8.23503 18.8758L9.10253 19.2091C9.68023 19.4313 10.3198 19.4313 10.8975 19.2091L11.765 18.8758C15.5967 17.4018 18.125 13.7204 18.125 9.61494V3.26994C18.1283 2.78223 17.8452 2.33796 17.4017 2.13494C15.0682 1.11644 12.546 0.602161 10 0.625778C7.45408 0.602161 4.93183 1.11644 2.59836 2.13494C2.1549 2.33796 1.87177 2.78223 1.87503 3.26994Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.25 9.62598C6.25 8.79755 6.92157 8.12598 7.75 8.12598H12.25C13.0784 8.12598 13.75 8.79755 13.75 9.62598V12.876C13.75 13.7044 13.0784 14.376 12.25 14.376H7.75C6.92157 14.376 6.25 13.7044 6.25 12.876V9.62598Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 4.37598V4.37598C8.61929 4.37598 7.5 5.49526 7.5 6.87598V8.12598H12.5V6.87598C12.5 5.49526 11.3807 4.37598 10 4.37598Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10 10.9624C10.1726 10.9624 10.3125 11.1023 10.3125 11.2749C10.3125 11.4475 10.1726 11.5874 10 11.5874C9.82741 11.5874 9.6875 11.4475 9.6875 11.2749C9.6875 11.1023 9.82741 10.9624 10 10.9624"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const SoundAndCameraIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M7.5 10.625H1.875C1.18464 10.625 0.625 10.0654 0.625 9.375V1.875C0.625 1.18464 1.18464 0.625 1.875 0.625H11.875C12.5654 0.625 13.125 1.18464 13.125 1.875V7.5"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.3158 8.46906L18.4708 9.54656C18.6646 9.64328 18.8946 9.63282 19.0787 9.51893C19.2629 9.40504 19.375 9.20393 19.375 8.98739V2.26072C19.375 2.04418 19.2629 1.84308 19.0787 1.72918C18.8946 1.61529 18.6646 1.60483 18.4708 1.70156L16.3158 2.77906C15.8923 2.99089 15.6249 3.42385 15.625 3.89739V7.35239C15.6255 7.82533 15.8929 8.25749 16.3158 8.46906Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.2168 12.3884C15.9404 12.2533 15.6118 12.2824 15.3634 12.4639L12.4439 14.2997H10.8143C10.6002 14.2979 10.3942 14.3811 10.2414 14.5311C10.0887 14.6812 10.0019 14.8858 10 15.0999V16.1667C10.0019 16.3808 10.0887 16.5853 10.2414 16.7354C10.3942 16.8854 10.6002 16.9687 10.8143 16.9668H12.4439L15.3625 18.807C15.6106 18.9893 15.9396 19.0185 16.2159 18.8826C16.4889 18.7501 16.6634 18.4747 16.6667 18.1714V13.0996C16.6636 12.7964 16.4894 12.5211 16.2168 12.3884V12.3884Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const DevicesIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.375 16.875H18.125V19.375H14.375V16.875Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.375 16.8751H13.125V11.9385C13.125 11.2481 13.6846 10.6885 14.375 10.6885H18.125C18.8154 10.6885 19.375 11.2481 19.375 11.9385V16.8751Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.875 0.625H5.625V3.125H1.875V0.625Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.875 3.125H0.625V8.18833C0.625 8.87869 1.18464 9.43833 1.875 9.43833H5.625C6.31536 9.43833 6.875 8.87869 6.875 8.18833V3.125Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M16.25 10.6883V3.75C16.25 2.02411 14.8509 0.625 13.125 0.625C11.3991 0.625 10 2.02411 10 3.75V16.25C10 17.9759 8.60089 19.375 6.875 19.375C5.14911 19.375 3.75 17.9759 3.75 16.25V9.43833"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const MouseIcon: React.FC<IconProps> = ({
	width = 21,
	height = 20,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 21 20"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.875 9.375V9.375C6.18464 9.375 5.625 8.81536 5.625 8.125V5.625C5.625 4.93464 6.18464 4.375 6.875 4.375V4.375C7.56536 4.375 8.125 4.93464 8.125 5.625V8.125C8.125 8.81536 7.56536 9.375 6.875 9.375Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M13.125 6.875C13.125 3.42322 10.3268 0.625 6.875 0.625C3.42322 0.625 0.625 3.42322 0.625 6.875V13.125C0.625 16.5768 3.42322 19.375 6.875 19.375"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.5997 19.3584L10.1589 17.4051C9.74217 17.0717 9.55792 16.5261 9.68721 16.0084V16.0084C9.78731 15.6059 10.0651 15.2708 10.4421 15.0977C10.8191 14.9247 11.2543 14.9326 11.6247 15.1192L12.603 15.6084V11.2334C12.603 10.543 13.1627 9.9834 13.853 9.9834V9.9834C14.5434 9.9834 15.103 10.543 15.103 11.2334V13.7334L16.7639 14.0101C17.9694 14.2109 18.853 15.2538 18.853 16.4759V19.3584"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const AccountManagementIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	fill = 'none',
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill={fill}
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M18.125 10.625V18.125C18.125 18.8154 17.5654 19.375 16.875 19.375H3.125C2.43464 19.375 1.875 18.8154 1.875 18.125V10.625"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.6233 0.625H2.37667C2.08365 0.624951 1.82982 0.82822 1.76583 1.11417L0.625 6.25C0.625 7.28553 1.46447 8.125 2.5 8.125C3.53553 8.125 4.375 7.28553 4.375 6.25C4.375 7.28553 5.21447 8.125 6.25 8.125C7.28553 8.125 8.125 7.28553 8.125 6.25C8.125 7.28553 8.96447 8.125 10 8.125C11.0355 8.125 11.875 7.28553 11.875 6.25C11.875 7.28553 12.7145 8.125 13.75 8.125C14.7855 8.125 15.625 7.28553 15.625 6.25C15.625 7.28553 16.4645 8.125 17.5 8.125C18.5355 8.125 19.375 7.28553 19.375 6.25L18.2333 1.11417C18.17 0.828173 17.9163 0.624715 17.6233 0.625Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.625 13.75C15.625 12.3693 14.5057 11.25 13.125 11.25C11.7443 11.25 10.625 12.3693 10.625 13.75V19.375H15.625V13.75Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.375 13.875C4.375 13.4608 4.71079 13.125 5.125 13.125H7.375C7.78921 13.125 8.125 13.4608 8.125 13.875V16.125C8.125 16.5392 7.78921 16.875 7.375 16.875H5.125C4.71079 16.875 4.375 16.5392 4.375 16.125V13.875Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const AddStoreIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	fill = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 22 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			d="M10.625 0C10.9702 0 11.25 0.279822 11.25 0.625V10H20.625C20.9702 10 21.25 10.2798 21.25 10.625C21.25 10.9702 20.9702 11.25 20.625 11.25H11.25V20.625C11.25 20.9702 10.9702 21.25 10.625 21.25C10.2798 21.25 10 20.9702 10 20.625V11.25H0.625C0.279822 11.25 0 10.9702 0 10.625C0 10.2798 0.279822 10 0.625 10H10V0.625C10 0.279822 10.2798 0 10.625 0Z"
			fill={fill}
		/>
	</svg>
);
export { LogsIcon as CollectLogsIcon } from '../LogsIcon/LogsIcon';
export { FeedbackIcon as SendFeedbackIcon } from '../FeedbackIcon/FeedbackIcon';
export { ConfigurationIcon as CheckConfigurationIcon } from '../ConfigurationIcon/ConfigurationIcon';
export { ResetCWAIcon } from '../ResetCWAIcon/ResetCWAIcon';
export { HelpCircleIcon as HelpDocumentationIcon } from '../HelpCircleIcon/HelpCircleIcon';
